import styled from 'styled-components'

export const StyledCategoriesTitle = styled.p`
font-style: normal;
font-weight: 400;
font-size: 12px;
`
export const StyledSettingsWrapper = styled.div`
& .recalculateSettings {
    margin-left: 20px;
    & .row:first-child > div:nth-child(2) {
        margin-right: 40px;
        margin-left: 20px;
    }
    & .row:last-child button {
        margin-left: 59px;
    }
}
`
export const StyledBlockCategories = styled.div`
width: 240px;
height: 125px;
display: inline-block;
overflow: auto;
background: #FFFFFF;
box-shadow: 0px 1px 2px rgba(90, 90, 90, 0.12);
// background: linear-gradient(180deg, rgba(255, 255, 255, 0) 70%, #e3e3e3 100%);
border-radius: 3px;
margin-bottom: 40px;
`
export const StyledCategoriesCheckboxes = styled.div`
display: flex;
flex-direction: column;
padding: 15.5px 0 12.5px 12.5px;
`

export const StyledSecondRow = styled.div`
display: flex;
align-items: center;
& .calculateButton {
    width: 300px;
    height: 36px;
}
& .commentInput input {
    max-width: 340px;
    width: 340px;
}
`

export const StyledTableContainer = styled.div`
	& .dx-datagrid-rowsview .cell-colored {
		background-color: ${({ bgColor }) => bgColor + '!important'};
        width: 100px;
	}
    & .dx-datagrid-content .dx-datagrid-table .dx-row > td {
        padding: 0 10px;
    }
`
